<template>
  <v-card>
    <v-data-table
      :headers="headers"
      :items="log"
      item-key="id"
      hide-actions>
      <template slot="items" slot-scope="props">
        <case-service-log-details-item :case-id="caseId"
                                       :item="props.item"/>
      </template>
    </v-data-table>
  </v-card>
</template>

<script>
  import NoEmpty from '../../Filters/NoEmpty.js'
  import DateWithMinutes from '../../Filters/DateWithMinutes.js'
  import {mapState} from "vuex";
  import CaseServiceLogDetailsItem from './CaseServiceLogDetailsItem'

  export default {
    name: 'case-service-log-details',
    components: {
      CaseServiceLogDetailsItem
    },
    filters: {
      NoEmpty,
      DateWithMinutes
    },
    props: {
      caseId: {
        type: String,
        required: true
      },
      log: {
        type: Array,
        required: true
      }
    },
    data() {
      return {
        headers: [
          {
            text: 'Id',
            align: 'left',
            sortable: false,
            value: 'id',
            width: '50px'
          },
          {
            text: 'Event',
            align: 'left',
            sortable: false,
            value: 'event',
            width: '50px'
          },
          {
            text: 'Invoice',
            align: 'left',
            sortable: false,
            width: '50px'
          },
          {
            text: 'CreatedAt',
            align: 'left',
            sortable: false,
            value: 'createdAt',
            width: '70px'
          },
          {
            text: 'OccurredDate',
            align: 'left',
            sortable: false,
            value: 'occurredAt',
            width: '70px'
          },
          {
            text: 'Change qty',
            align: 'left',
            sortable: false,
            value: 'changeQty',
            width: '100px'
          },
          {
            text: 'Comment',
            align: 'left',
            sortable: false,
            width: '100px'
          },
          {
            text: 'Actions',
            align: 'left',
            sortable: false,
            width: '200px'
          },
        ],
      }
    },
    computed: {
      ...mapState({
        devMode: 'devMode'
      }),
    },
    methods: {
      getEventColor(event) {
        return getEventColor(event)
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/Sales/case/CaseServiceLogDetails.vue